import { render } from "./B2bTableCommercialRelation.vue?vue&type=template&id=10d79a0a&scoped=true&lang=pug"
import script from "./B2bTableCommercialRelation.vue?vue&type=script&lang=js"
export * from "./B2bTableCommercialRelation.vue?vue&type=script&lang=js"

import "./B2bTableCommercialRelation.vue?vue&type=style&index=0&id=10d79a0a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10d79a0a"]])

export default __exports__